
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

interface UseBackButtonLogoutProps {
  onLogoutRequest: () => void;
}

export const useBackButtonLogout = ({ onLogoutRequest }: UseBackButtonLogoutProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      // Replace the current state to prevent actual back navigation
      window.history.pushState(null, '', location.pathname);
      
      // Show logout confirmation
      onLogoutRequest();
    };

    // Replace current state (don't add new history entry) to enable back button detection
    window.history.replaceState(null, '', location.pathname);
    
    // Listen for back button
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [location.pathname, onLogoutRequest]);
};
